import { Message } from 'element-ui' //使用elementui的提示显示
import * as XLSX from "xlsx";

export function hasLetter(str) {
  for (var i in str) {
    var asc = str.charCodeAt(i);
    if ((asc >= 65 && asc <= 90 || asc >= 97 && asc <= 122)) {
      return true;
    }
  }
  return false;
}

export function param2Obj(url) {
  const search = decodeURIComponent(url.split('?')[1]).replace(/\+/g, ' ')
  if (!search) {
    return {}
  }
  const obj = {}
  const searchArr = search.split('&')
  searchArr.forEach(v => {
    const index = v.indexOf('=')
    if (index !== -1) {
      const name = v.substring(0, index)
      const val = v.substring(index + 1, v.length)
      obj[name] = val
    }
  })
  return obj
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string')) {
      if ((/^[0-9]+$/.test(time))) {
        // support "1548221490638"
        time = parseInt(time)
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/')
      }
    }

    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
    const value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    return value.toString().padStart(2, '0')
  })
  return time_str
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

export function getSearchString() {
  let data = {};
  let src = window.location.href;
  let dataStr = src.substring(src.indexOf("?") + 1);
  let dataArray = dataStr.split("&");
  for (let i = 0; i < dataArray.length; i++) {
    let param = dataArray[i].split("=");
    data[param[0]] = param[1];
  }
  return data;
}
export function apkNameSub(name,length){
  if(name && name.length>length){
     let newName = name.substring(0,length) + '...'
     return newName;
  }else if(name && name.length<=length){
     return name;
  }
}
export function messageFn(type, message) {
  Message({
    type: type,
    message: message
  })
}
export const readFile = (file) => {
  const { name = "" } = file;
  const reader = new FileReader();
  const XLSXRegExp = /.xlsx/i;

  return new Promise((resolve, reject) => {
    try {
      if (XLSXRegExp.test(name)) {
        reader.readAsBinaryString(file);
      } else {
        reader.readAsText(file);
      }

      reader.onload = (e) => {
        const fileData = e.target.result;

        if (XLSXRegExp.test(name)) {
          const xlsxFileData = XLSX.read(fileData, { type: 'binary' });
          resolve(xlsxFileData);
        } else {
          resolve(fileData);
        }
      };
    } catch (error) {
      reject(error);
    }
  });
};

export const xlsxToTable = ({
  Sheets = {},
}, fields) => {
  console.log(fields)
  console.log(Sheets)
  // findSheetNames
  const SheetLength = fields.length;
  const PureSheetName = fields.map(field => field.label);

  // findSheetValues
  const allSheetValues = Object.values(Sheets)[0];
  const SheetValues = Object.values(allSheetValues);
  const PureSheetValue = SheetValues.filter((_, index) => index !== 0 && index !== SheetValues.length - 1 && !PureSheetName.includes(_.v));
  console.log(PureSheetValue)
  // concatToTable()
  let temp = {};
  let depth = 0;
  let result = [];

  PureSheetValue.forEach(({ v: value }) => {
    const { prop } = fields[depth];
    ++depth;
    temp[prop] = value;

    if (depth === SheetLength) {
      const newTemp = JSON.parse(JSON.stringify(temp));
      result.push(newTemp);
      temp = {};
      depth = 0;
    }
  });

  return {
    column: fields,
    data: result
  }
}




// WEBPACK FOOTER //
// ./src/global/index.js